// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__pEiwD","itemTitle":"ClientEmergencyInfo_itemTitle__1MfzC","itemText":"ClientEmergencyInfo_itemText__2E2dR"};